import React from 'react';
import styled from 'styled-components';
const GraphicSVG = styled.svg.withConfig({ displayName: "GraphicSVG", componentId: "sc-kkq94t" }) `display:inline-block;vertical-align:middle;`;
const Graphic = ({ children, ...rest }) => {
    return React.createElement(GraphicSVG, Object.assign({}, rest), children);
};
Graphic.defaultProps = {
    focusable: 'false',
    'aria-hidden': 'true', // mostly decorative
};
export default Graphic;
//# sourceMappingURL=component.js.map